/* Jadel Custom JS — juli 2026 */

document.addEventListener('DOMContentLoaded', function() {

  /* === SEO tekst inklapbaar === */
  var collectionDesc = document.querySelector('.collection .rte, .collection-description, [class*="collection"] .rte');
  if (collectionDesc && collectionDesc.scrollHeight > 150) {
    collectionDesc.classList.add('collection-seo-text');
    var btn = document.createElement('button');
    btn.className = 'seo-toggle-btn';
    btn.textContent = 'Lees meer';
    btn.addEventListener('click', function() {
      collectionDesc.classList.toggle('expanded');
      btn.textContent = collectionDesc.classList.contains('expanded') ? 'Lees minder' : 'Lees meer';
    });
    collectionDesc.parentNode.insertBefore(btn, collectionDesc.nextSibling);
  }

  /* === Winkelwagen animatie === */
  document.querySelectorAll('.product-form__submit').forEach(function(b) {
    b.addEventListener('click', function() {
      setTimeout(function() {
        b.classList.add('added');
        b.addEventListener('animationend', function() {
          b.classList.remove('added');
        }, { once: true });
      }, 300);
    });
  });

  /* === Verberg Judge.me 'Geen beoordelingen' === */
  document.querySelectorAll('.jdgm-preview-badge').forEach(function(badge) {
    if (!badge.querySelector('.jdgm-prev-badge__stars') ||
        badge.getAttribute('data-average-rating') === '0.00' ||
        badge.textContent.trim().includes('Geen beoordelingen')) {
      badge.style.display = 'none';
    }
  });

  /* === Zoekfilter + Tag-filters ALLEEN op collectiepagina’s === */
  var productGrid = document.querySelector('#product-grid, .product-grid, [id^="product-grid"]');
  var isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1;
  if (!productGrid || !isCollectionPage) return;

  var pathParts = window.location.pathname.split('/');
  var collIdx = pathParts.indexOf('collections');
  var collectionHandle = (collIdx !== -1 && pathParts[collIdx + 1]) ? pathParts[collIdx + 1] : null;
  if (!collectionHandle) return;

  var originalGridHTML = productGrid.innerHTML;

  /* Helper: normalize product.tags (kan string of array zijn) */
  function getTagsArray(product) {
    if (!product.tags) return [];
    if (Array.isArray(product.tags)) {
      return product.tags.map(function(t) { return t.toLowerCase().trim(); });
    }
    return product.tags.toLowerCase().split(',').map(function(t) { return t.trim(); });
  }

  /* --- AJAX: Fetch ALL products in collection --- */
  var jadelAllProducts = null;
  var jadelFetchPromise = null;

  function fetchAllProducts() {
    if (jadelFetchPromise) return jadelFetchPromise;
    jadelFetchPromise = new Promise(function(resolve) {
      var allProducts = [];
      var page = 1;
      function fetchPage() {
        fetch('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (data.products && data.products.length > 0) {
              allProducts = allProducts.concat(data.products);
              if (data.products.length === 250) {
                page++;
                fetchPage();
              } else {
                jadelAllProducts = allProducts;
                resolve(allProducts);
              }
            } else {
              jadelAllProducts = allProducts;
              resolve(allProducts);
            }
          })
          .catch(function() {
            jadelAllProducts = allProducts;
            resolve(allProducts);
          });
      }
      fetchPage();
    });
    return jadelFetchPromise;
  }

  /* --- ZOEKBALK (inklapbaar icoon) --- */
  var searchContainer = document.createElement('div');
  searchContainer.className = 'jadel-collection-search';

  var toggleBtn = document.createElement('button');
  toggleBtn.type = 'button';
  toggleBtn.className = 'jadel-collection-search__toggle';
  toggleBtn.setAttribute('aria-label', 'Zoeken in collectie');
  toggleBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

  var searchWrapper = document.createElement('div');
  searchWrapper.className = 'jadel-collection-search__wrapper';
  var input = document.createElement('input');
  input.type = 'text';
  input.className = 'jadel-collection-search__input';
  input.placeholder = 'Zoek in deze collectie...';
  input.setAttribute('autocomplete', 'off');
  var clearBtn = document.createElement('button');
  clearBtn.type = 'button';
  clearBtn.className = 'jadel-collection-search__clear';
  clearBtn.innerHTML = '&times;';
  searchWrapper.appendChild(input);
  searchWrapper.appendChild(clearBtn);

  var countLabel = document.createElement('span');
  countLabel.className = 'jadel-collection-search__count';

  searchContainer.appendChild(toggleBtn);
  searchContainer.appendChild(searchWrapper);
  searchContainer.appendChild(countLabel);
  productGrid.parentNode.insertBefore(searchContainer, productGrid);

  toggleBtn.addEventListener('click', function() {
    var isOpen = searchWrapper.classList.toggle('is-open');
    toggleBtn.classList.toggle('is-active', isOpen);
    if (isOpen) {
      fetchAllProducts();
      setTimeout(function() { input.focus(); }, 250);
    } else {
      input.value = '';
      clearAllFilters();
    }
  });

  /* --- TAG-FILTERS: Inject into Shopify filter bar --- */
  var filterConfig = null;
  var configEl = document.getElementById('jadel-filter-config');
  if (configEl) {
    try { filterConfig = JSON.parse(configEl.textContent); } catch(e) {}
  }

  var activeFilters = {};
  var facetsWrapper = document.getElementById('FacetsWrapperDesktop');

  if (filterConfig && filterConfig.length > 0 && facetsWrapper) {
    fetchAllProducts().then(function() {
      hideNonExistentTags();
    });

    filterConfig.forEach(function(group, gi) {
      if (!group.tags || group.tags.length === 0) return;
      activeFilters[group.naam] = [];

      var details = document.createElement('details');
      details.className = 'disclosure-has-popup facets__disclosure js-filter jadel-tag-detail';
      details.id = 'Details-jadel-tag-' + gi;

      var summary = document.createElement('summary');
      summary.className = 'facets__summary caption-large focus-offset';
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');
      summary.innerHTML = '<div><span>' + group.naam + '</span>' +
        '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></div>';
      details.appendChild(summary);

      var dropdown = document.createElement('div');
      dropdown.className = 'facets__display jadel-tag-dropdown';

      var btnRow = document.createElement('div');
      btnRow.className = 'jadel-tag-dropdown__buttons';

      group.tags.forEach(function(tag) {
        var tagLower = tag.toLowerCase();
        var tagBtn = document.createElement('button');
        tagBtn.type = 'button';
        tagBtn.className = 'jadel-tag-btn';
        tagBtn.textContent = tag.charAt(0).toUpperCase() + tag.slice(1);
        tagBtn.dataset.tag = tagLower;
        tagBtn.dataset.group = group.naam;
        tagBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          tagBtn.classList.toggle('is-active');
          var groupTags = activeFilters[group.naam];
          var idx = groupTags.indexOf(tagLower);
          if (idx === -1) { groupTags.push(tagLower); } else { groupTags.splice(idx, 1); }
          applyFilters();
        });
        btnRow.appendChild(tagBtn);
      });

      dropdown.appendChild(btnRow);
      details.appendChild(dropdown);

      document.addEventListener('click', function(e) {
        if (!details.contains(e.target)) details.removeAttribute('open');
      });

      facetsWrapper.appendChild(details);
    });
  }

  function hideNonExistentTags() {
    if (!jadelAllProducts) return;
    var allTagsSet = {};
    jadelAllProducts.forEach(function(p) {
      getTagsArray(p).forEach(function(t) { allTagsSet[t] = true; });
    });
    document.querySelectorAll('.jadel-tag-btn').forEach(function(btn) {
      if (!allTagsSet[btn.dataset.tag]) btn.style.display = 'none';
    });
  }

  /* --- GECOMBINEERDE FILTER LOGICA (AJAX) --- */
  var isFiltering = false;

  var debounceTimer;
  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { applyFilters(); }, 200);
  });

  clearBtn.addEventListener('click', function() {
    input.value = '';
    applyFilters();
    input.focus();
  });

  function clearAllFilters() {
    input.value = '';
    Object.keys(activeFilters).forEach(function(k) { activeFilters[k] = []; });
    document.querySelectorAll('.jadel-tag-btn.is-active').forEach(function(b) { b.classList.remove('is-active'); });
    if (isFiltering) {
      productGrid.innerHTML = originalGridHTML;
      isFiltering = false;
      document.querySelectorAll('.pagination, .pagination-wrapper, nav[role="navigation"]').forEach(function(p) { p.style.display = ''; });
    }
    countLabel.style.display = 'none';
  }

  function applyFilters() {
    var query = input.value.trim().toLowerCase();
    var words = query ? query.split(/\s+/) : [];
    var hasSearch = words.length > 0;

    var hasTagFilters = false;
    var activeGroupFilters = [];
    Object.keys(activeFilters).forEach(function(groupName) {
      var tags = activeFilters[groupName];
      if (tags.length > 0) {
        hasTagFilters = true;
        activeGroupFilters.push(tags);
      }
    });

    if (!hasSearch && !hasTagFilters) {
      clearAllFilters();
      return;
    }

    if (!jadelAllProducts) {
      countLabel.style.display = 'inline';
      countLabel.textContent = 'Laden...';
      fetchAllProducts().then(function() {
        hideNonExistentTags();
        applyFilters();
      });
      return;
    }

    isFiltering = true;

    var filtered = jadelAllProducts.filter(function(product) {
      var ptags = getTagsArray(product);
      if (ptags.indexOf('actie') !== -1) return false;
      if (ptags.indexOf('sale') !== -1) return false;
      if (ptags.indexOf('maak-eigen-ketting') !== -1) {
        if (collectionHandle.indexOf('kralen') === -1) return false;
      }

      if (hasSearch) {
        var title = product.title.toLowerCase();
        var matched = words.every(function(w) { return title.indexOf(w) !== -1; });
        if (!matched) return false;
      }

      if (hasTagFilters) {
        var pass = activeGroupFilters.every(function(groupTags) {
          return groupTags.some(function(tag) {
            return ptags.indexOf(tag) !== -1;
          });
        });
        if (!pass) return false;
      }

      return true;
    });

    renderFilteredProducts(filtered);

    var totalVisible = jadelAllProducts.filter(function(p) {
      var ptags = getTagsArray(p);
      if (ptags.indexOf('actie') !== -1) return false;
      if (ptags.indexOf('sale') !== -1) return false;
      if (ptags.indexOf('maak-eigen-ketting') !== -1 && collectionHandle.indexOf('kralen') === -1) return false;
      return true;
    }).length;

    countLabel.style.display = 'inline';
    countLabel.textContent = filtered.length + ' / ' + totalVisible;

    document.querySelectorAll('.pagination, .pagination-wrapper, nav[role="navigation"]').forEach(function(p) { p.style.display = 'none'; });
  }

  function renderFilteredProducts(products) {
    productGrid.innerHTML = '';
    if (products.length === 0) {
      productGrid.innerHTML = '<li class="grid__item jadel-no-results" style="grid-column:1/-1;text-align:center;padding:40px 20px;"><p style="font-size:16px;color:#666;">Geen producten gevonden</p></li>';
      return;
    }
    products.forEach(function(product) {
      var li = document.createElement('li');
      li.className = 'grid__item jadel-ajax-product';

      var img = (product.images && product.images.length > 0) ? product.images[0].src : '';
      var price = product.variants && product.variants[0] ? product.variants[0].price : '0.00';
      var comparePrice = product.variants && product.variants[0] ? product.variants[0].compare_at_price : null;
      var url = '/products/' + product.handle;

      var priceNum = parseFloat(price);
      var priceFormatted = '€' + priceNum.toFixed(2).replace('.', ',');
      var discountHTML = '';

      if (comparePrice && parseFloat(comparePrice) > priceNum) {
        var compareNum = parseFloat(comparePrice);
        var pct = Math.round((1 - priceNum / compareNum) * 100);
        discountHTML = '<span class="jadel-ajax-product__compare">€' + compareNum.toFixed(2).replace('.', ',') + '</span>' +
          '<span class="jadel-ajax-product__discount">-' + pct + '%</span>';
      }

      li.innerHTML = '<a href="' + url + '" class="jadel-ajax-product__link">' +
        '<div class="jadel-ajax-product__img-wrap">' +
          (img ? '<img src="' + img.replace(/\.([a-z]+)$/i, '_400x.$1') + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          (discountHTML ? '<span class="jadel-ajax-product__badge">-' + pct + '%</span>' : '') +
        '</div>' +
        '<div class="jadel-ajax-product__info">' +
          '<h3 class="jadel-ajax-product__title">' + product.title + '</h3>' +
          '<div class="jadel-ajax-product__price">' + discountHTML + ' ' + priceFormatted + '</div>' +
        '</div></a>';

      productGrid.appendChild(li);
    });
  }

});
